import { addIcon } from '@iconify/vue'
import riAddLine from '@iconify-icons/ri/add-line'
import riArrowDownSFill from '@iconify-icons/ri/arrow-down-s-fill'
import riArrowDownSLine from '@iconify-icons/ri/arrow-down-s-line'
import riArrowLeftSLine from '@iconify-icons/ri/arrow-left-s-line'
import riArrowRightSLine from '@iconify-icons/ri/arrow-right-s-line'
import riBarChartLine from '@iconify-icons/ri/bar-chart-line'
import riCheckLine from '@iconify-icons/ri/check-line'
import riCloseLine from '@iconify-icons/ri/close-line'
import riCursorFill from '@iconify-icons/ri/cursor-fill'
import riDeleteBin7Line from '@iconify-icons/ri/delete-bin-7-line'
import riDownloadLine from '@iconify-icons/ri/download-line'
import riEditBoxLine from '@iconify-icons/ri/edit-box-line'
import riFileCloseFill from '@iconify-icons/ri/file-close-fill'
import riFileCopyLine from '@iconify-icons/ri/file-copy-line'
import riFileDownloadLine from '@iconify-icons/ri/file-download-line'
import riFileList3Line from '@iconify-icons/ri/file-list-3-line'
import riInformationFill from '@iconify-icons/ri/information-fill'
import riLoader4Line from '@iconify-icons/ri/loader-4-line'
import riLogoutBoxRLine from '@iconify-icons/ri/logout-box-r-line'
import riMailAddLine from '@iconify-icons/ri/mail-add-line'
import riMailCloseLine from '@iconify-icons/ri/mail-close-line'
import riMore2Line from '@iconify-icons/ri/more-2-line'
import riNumbersFill from '@iconify-icons/ri/numbers-fill'
import riQrCodeFill from '@iconify-icons/ri/qr-code-fill'
import riSearchLine from '@iconify-icons/ri/search-line'
import riSubtractLine from '@iconify-icons/ri/subtract-line'
import riToolsLine from '@iconify-icons/ri/tools-line'
import riUser4Fill from '@iconify-icons/ri/user-4-fill'
import riUserAddLine from '@iconify-icons/ri/user-add-line'
import riUserSmileFill from '@iconify-icons/ri/user-smile-fill'
import riWalletLine from '@iconify-icons/ri/wallet-line'

/**
 * 預先註冊 Iconify 圖示到記憶體中，避免執行時從 CDN 載入造成閃爍
 * 以下 6 個圖示因 @iconify-icons/ri 尚未收錄，仍會走 CDN 按需載入：
 * - ri:arrow-up-long-line
 * - ri:arrow-down-long-line
 * - ri:chat-smile-ai-line
 * - ri:close-large-line
 * - ri:reset-right-line
 * - ri:shopping-bag-4-fill
 */
export const registerIcons = () => {
  addIcon('ri:add-line', riAddLine)
  addIcon('ri:arrow-down-s-fill', riArrowDownSFill)
  addIcon('ri:arrow-down-s-line', riArrowDownSLine)
  addIcon('ri:arrow-left-s-line', riArrowLeftSLine)
  addIcon('ri:arrow-right-s-line', riArrowRightSLine)
  addIcon('ri:bar-chart-line', riBarChartLine)
  addIcon('ri:check-line', riCheckLine)
  addIcon('ri:close-line', riCloseLine)
  addIcon('ri:cursor-fill', riCursorFill)
  addIcon('ri:delete-bin-7-line', riDeleteBin7Line)
  addIcon('ri:download-line', riDownloadLine)
  addIcon('ri:edit-box-line', riEditBoxLine)
  addIcon('ri:file-close-fill', riFileCloseFill)
  addIcon('ri:file-copy-line', riFileCopyLine)
  addIcon('ri:file-download-line', riFileDownloadLine)
  addIcon('ri:information-fill', riInformationFill)
  addIcon('ri:loader-4-line', riLoader4Line)
  addIcon('ri:logout-box-r-line', riLogoutBoxRLine)
  addIcon('ri:mail-add-line', riMailAddLine)
  addIcon('ri:mail-close-line', riMailCloseLine)
  addIcon('ri:more-2-line', riMore2Line)
  addIcon('ri:numbers-fill', riNumbersFill)
  addIcon('ri:qr-code-fill', riQrCodeFill)
  addIcon('ri:search-line', riSearchLine)
  addIcon('ri:subtract-line', riSubtractLine)
  addIcon('ri:tools-line', riToolsLine)
  addIcon('ri:user-4-fill', riUser4Fill)
  addIcon('ri:user-add-line', riUserAddLine)
  addIcon('ri:user-smile-fill', riUserSmileFill)
  addIcon('ri:wallet-line', riWalletLine)
  addIcon('ri:file-list-3-line', riFileList3Line)
}
